module.exports = __webpack_public_path__ + "img/pg-blockchain.079249e3.jpg";